module.exports = __webpack_public_path__ + "img/message-circle.ebbe6d9a.svg";